import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Customers from './components/Customers';
import Products from './components/Products';
import OrderEntry from './components/OrderEntry';
import OrderHistory from './components/OrderHistory'; // already imported
import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [employeeName, setEmployeeName] = useState('');
  const [currentView, setCurrentView] = useState('dashboard');
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const name = localStorage.getItem('employeeName');
    if (name) {
      setEmployeeName(name);
      setIsLoggedIn(true);
    }
  }, []);

  const handleLoginSuccess = (userData) => {
    setEmployeeName(userData.employeeName);
    setIsLoggedIn(true);
    setCurrentView('dashboard');
  };

  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setCart([]);
  };

  const addToCart = (product) => {
    setCart(prevCart => {
      const existing = prevCart.find(item => item.productID === product.productID);
      if (existing) {
        return prevCart.map(item =>
          item.productID === product.productID
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prevCart, { ...product, quantity: 1 }];
    });
    alert(`${product.productName} added to cart`);
  };

  if (!isLoggedIn) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  const renderView = () => {
    switch (currentView) {
      case 'dashboard':
        return <Dashboard employeeName={employeeName} onNavigate={setCurrentView} />;
      case 'customers':
        return <Customers onBack={() => setCurrentView('dashboard')} />;
      case 'products':
        return <Products onBack={() => setCurrentView('dashboard')} addToCart={addToCart} />;
      case 'orders':
        return <OrderEntry onBack={() => setCurrentView('dashboard')} addToCart={addToCart} cart={cart} setCart={setCart} />;
      case 'history':                       // 👈 new case
        return <OrderHistory onBack={() => setCurrentView('dashboard')} />;
      default:
        return <Dashboard employeeName={employeeName} onNavigate={setCurrentView} />;
    }
  };

  return (
    <div className="app">
      {renderView()}
      {currentView !== 'orders' && cart.length > 0 && (
        <div className="floating-cart" onClick={() => setCurrentView('orders')}>
          🛒 {cart.reduce((sum, item) => sum + item.quantity, 0)}
        </div>
      )}
      <button className="logout-btn" onClick={handleLogout}>🚪 Logout</button>
    </div>
  );
}

export default App;